// The backend (henkikirjahaku-backend) validates the request's Origin header
// against its own DOMAIN env var, so this must keep pointing at a host that
// backend is configured to allow. Override for local development with a
// REACT_APP_API_BASE_URL entry in a (gitignored) .env.local file instead of
// editing this default.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://api-henkikirjahaku.genealogia.fi";

export async function fetchJson(url) {
  const response = await fetch(url);
  return response.json();
}
